import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import UploaderWithProvider from '../../../components/uploading/Uploader';
import { DataManagementContext } from '../../../components/viewers/DataManagementViewer';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { UiItemContext } from '../../../cnr/contexts/UiItemContext';
import { gEnums } from '../../../enums/globalEnums';
import ImageGallery from '../../../components/imaging/ImageGallery';
import FullPageWrapper from '../../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper';
import { DataModificationsContext } from '../UiDataModifications';
import { dataModificationTypes } from '../../../viewSettings/enums/itemActionTypes';
import { FrameworkContext } from '../../../cnr/contexts/FrameworkContent';

/** Component for Uploading Images 
  @description updates using (storage_handlers.handleUpdate_gallery)
 */
const UiUpload = (props) => {

  const { handleCancel: _handleCancel } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, storage_state } = states ?? {}
  const { currentGalleryItems, selectedItems } = storage_state ?? {}
  const { aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { useClientProfileImage, appUserCollection } = aps_appUserSettings ?? {}

  // dataManagementContext
  const frameworkContext = useContext(FrameworkContext)
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { selectedDataMode, selectedCollectionKey } = framework_state ?? {}
  const { handleShow_appDashboard } = framework_handlers ?? {}

  // dataManagementContext
  const dataManagementContext = useContext(DataManagementContext)
  const { dataManagement_state, dataManagement_handlers } = dataManagementContext ?? {}
  const { viewItem, dataManagementType } = dataManagement_state ?? {}
  const { key: viewItemKey } = viewItem ?? {}

  // dataManagementContext
  const dataModificationsContext = useContext(DataModificationsContext)
  const { dataModifications_state, dataModifications_handlers } = dataModificationsContext ?? {}
  const { dataModificationType } = dataModifications_state ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state, item_handlers } = uiItemContext ?? {}
  const { viewItem_key, dataName, _modifyActionProps } = item_state ?? {}
  const { handleClose_openedItem } = item_handlers ?? {}
  const { modifyItemData } = _modifyActionProps ?? {}

  let _viewItemKey = viewItemKey ? viewItemKey : viewItem_key
  if (!_viewItemKey && selectedCollectionKey) { _viewItemKey = selectedCollectionKey }

  let storageType = gEnums.storageTypes.image

  // local state
  const [selectedImage, setSelectedImage] = useState()
  const [showUpload] = useState(props.showUpload)

  const { storageLocationType, topperCaption, useFull } = useMemo(() => {
    let _storageLocationType = gEnums.storageLocationTypes.pages;
    let _topperCaption;
    let _useFull = true;

    switch (dataManagementType) {
      case dataModificationTypes.bulkImageUpload:
      case dataModificationTypes.upload_storageImages:
        _storageLocationType =
          appUserCollection === _viewItemKey
            ? gEnums.storageLocationTypes.clientProfiles
            : gEnums.storageLocationTypes.pages;
        _topperCaption = showUpload ? 'Bulk Upload' : 'Bulk Images';
        break;
      default:
        _topperCaption = showUpload ? 'Upload' : 'Images';
        if (selectedDataMode) {
          _storageLocationType =
            appUserCollection === selectedCollectionKey
              ? gEnums.storageLocationTypes.clientProfiles
              : gEnums.storageLocationTypes.pages;
          _useFull = true;
        } else {
          _useFull = false;
        }
        break;
    }

    if (dataModificationType === dataModificationTypes.pdfs) {
      _topperCaption = showUpload ? 'Upload' : 'PDFs';
      _storageLocationType = gEnums.storageLocationTypes.pagePdf;
    }

    if (_storageLocationType === gEnums.storageLocationTypes.clientProfiles) {
      _topperCaption = showUpload ? 'Bulk Upload' : 'Bulk Images';
    }

    return { storageLocationType: _storageLocationType, topperCaption: _topperCaption, useFull: _useFull };
  }, [dataManagementType, selectedDataMode, showUpload, selectedCollectionKey, appUserCollection, dataModificationType]);

  const _selectedImage = useMemo(() => {
    if (!currentGalleryItems || !selectedItems) return undefined;

    for (const key of Object.keys(selectedItems)) {
      if (currentGalleryItems[key]) {
        return { key, image: currentGalleryItems[key] };
      }
    }

    return undefined;
  }, [currentGalleryItems, selectedItems]);

  // If you need to update state based on `selectedImage`, useEffect can be minimal:
  useEffect(() => {
    setSelectedImage(_selectedImage);
  }, [_selectedImage]);

  const handleCancel = () => {
    if (handleClose_openedItem) {
      handleClose_openedItem()
    } else {
      _handleCancel && _handleCancel()
      dataManagement_handlers && dataManagement_handlers.handleSelect_dataActionOption()
      dataModifications_handlers && dataModifications_handlers.handleDataModificationSelect()
      handleShow_appDashboard && handleShow_appDashboard()
    }
  }

  // const handleSelect = () => storage_handlers.handleUpdate_gallery(selectedImage, _viewItemKey)

  const getTopperCaption2 = () => {
    const _caption = dataName ? dataName : _.startCase(_viewItemKey)
    if (useClientProfileImage) {
      return _caption + ' (to client)'
    } else {
      return _caption
    }
  }

  const wrapper_upload = () => <Wrapper
    content={<UploaderWithProvider
      handleCancel={handleCancel}
      origin={'uiUpload'}
      storageLocationType={storageLocationType}
      storageType={storageType}
      viewItemKey={_viewItemKey}
    />}
    css={{ footer: 'modify' }}
    wrapperType={wrapperTypes.upload}
  />

  const imageGallery = () => <ImageGallery
    storageLocationType={storageLocationType}
    storageType={storageType}
  />

  // current image gallery
  const fpw_images = () => <FullPageWrapper
    content={imageGallery()}
    topperCaption={topperCaption}
    topperCaption2={getTopperCaption2()}
    handleCancel={handleCancel}
    isBack={props && props.handleCancel ? true : false}
    fullMode={useFull}
    css={{ container: 'upload' }}
  />

  const fpw_upload = () => <FullPageWrapper
    content={wrapper_upload()}
    topperCaption={topperCaption}
    topperCaption2={getTopperCaption2()}
    handleCancel={handleCancel}
    isBack={true}
    fullMode={useFull}
    css={{ container: 'upload' }}
  />


  return showUpload ? fpw_upload() : fpw_images()
}

export default UiUpload